import React from 'react';
import { Box, Typography } from '@mui/material';
import Star from '../../assets/star.svg';

const RatingButton = ({rating}) => {
  return (
    <Box sx={{display:'flex', alignItems:'center', gap:1, borderRadius:'100px', backgroundColor:'rgba(18, 18, 18, 1)', height:'fit-content', py:1, px:2}}>
        <img src={Star} alt="star" style={{width:'16px', height:'16px'}}/>
        <Typography sx={{display:'flex', gap:1, color:'rgba(238, 230, 254, 1)'}}>
            <span>{rating}</span><span>Rating</span>
        </Typography>
    </Box>
  )
}

export default RatingButton